// extracted by mini-css-extract-plugin
export default {"givePulse":"GivePulse_givePulse__olpLB","action":"GivePulse_action__9nI3Y","separator":"GivePulse_separator__9Bff1","pulseData":"GivePulse_pulseData__8jMZi"};